import React from 'react';
import { useTranslation } from 'react-i18next';
import './ProductList.css';
import ProductCard from '../ProductCard/ProductCard';

const ProductList = ({ products }) => {
  const { t } = useTranslation();
  
  return (
    <div className="product-list-container">
      <h2 className="product-list-title">
        <span className="title-indicator"></span>
        {t('product.productList')}
      </h2>
      <div className="product-list">
        {products.map((product, index) => (
          <ProductCard key={index} product={product} />
        ))}
      </div>
    </div>
  );
};

export default ProductList;

